"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var difference_in_minutes_1 = __importDefault(require("date-fns/difference_in_minutes"));
var last_1 = __importDefault(require("lodash/last"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var react_scroll_to_bottom_1 = __importStar(require("react-scroll-to-bottom"));
var constants_1 = __importDefault(require("../../core/constants"));
var Avatar_1 = __importDefault(require("../common/Avatar"));
var MessageGroup_1 = __importDefault(require("./MessageGroup"));
var MessageList = /** @class */ (function (_super) {
    __extends(MessageList, _super);
    function MessageList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleKeyDown = function (e) {
            if (!_this.props.enableArrowNavigation) {
                return;
            }
            var maxScroll = _this.messagesDiv.scrollHeight - _this.messagesDiv.clientHeight;
            var shouldFocusNext = e.key === 'ArrowRight' || (e.key === 'ArrowDown' && _this.messagesDiv.scrollTop === maxScroll);
            var shouldFocusPrevious = e.key === 'ArrowLeft' || (e.key === 'ArrowUp' && _this.messagesDiv.scrollTop === 0);
            if (shouldFocusNext) {
                _this.messagesDiv.blur();
                _this.props.focusNext();
            }
            if (shouldFocusPrevious) {
                _this.messagesDiv.blur();
                _this.props.focusPrevious();
            }
        };
        return _this;
    }
    MessageList.prototype.componentDidMount = function () {
        var _this = this;
        (0, mobx_1.observe)(this.props.focusedArea, function (focus) {
            var _a;
            focus.newValue === 'convo' && ((_a = _this.messagesDiv) === null || _a === void 0 ? void 0 : _a.focus());
        });
    };
    MessageList.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(react_scroll_to_bottom_1.default, { mode: 'bottom', initialScrollBehavior: 'auto', tabIndex: 0, className: 'bpw-msg-list-scroll-container', scrollViewClassName: 'bpw-msg-list', ref: function (m) {
                _this.messagesDiv = m;
            }, followButtonClassName: 'bpw-msg-list-follow' },
            react_1.default.createElement(Content, __assign({}, this.props))));
    };
    return MessageList;
}(react_1.default.Component));
var Content = (0, mobx_react_1.observer)(function (props) {
    var _a, _b;
    var _c = (0, react_1.useState)({
        showNewMessageIndicator: false,
        messagesLength: undefined
    }), state = _c[0], setState = _c[1];
    var scrollToBottom = (0, react_scroll_to_bottom_1.useScrollToBottom)();
    var sticky = (0, react_scroll_to_bottom_1.useSticky)()[0];
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var stateUpdate = __assign(__assign({}, state), { messagesLength: (_a = props.currentMessages) === null || _a === void 0 ? void 0 : _a.length });
        if (!sticky && state.messagesLength !== ((_b = props.currentMessages) === null || _b === void 0 ? void 0 : _b.length)) {
            setState(__assign(__assign({}, stateUpdate), { showNewMessageIndicator: !(props === null || props === void 0 ? void 0 : props.alwaysScrollDownOnMessages) }));
            (props === null || props === void 0 ? void 0 : props.alwaysScrollDownOnMessages) && scrollToBottom();
        }
        else {
            setState(__assign(__assign({}, stateUpdate), { showNewMessageIndicator: false }));
        }
    }, [(_a = props.currentMessages) === null || _a === void 0 ? void 0 : _a.length, sticky]);
    var shouldDisplayMessage = function (m) {
        return m.payload.type !== 'postback';
    };
    var renderAvatar = function (name, url) {
        var avatarSize = props.isEmulator ? 20 : 40; // quick fix
        return react_1.default.createElement(Avatar_1.default, { name: name, avatarUrl: url, height: avatarSize, width: avatarSize });
    };
    var renderDate = function (date) {
        return (react_1.default.createElement("div", { className: 'bpw-date-container' },
            new Intl.DateTimeFormat(props.intl.locale || 'en', {
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            }).format(new Date(date)),
            react_1.default.createElement("div", { className: 'bpw-small-line' })));
    };
    var renderMessageGroups = function () {
        var messages = (props.currentMessages || []).filter(function (m) { return shouldDisplayMessage(m); });
        var groups = [];
        var lastSpeaker = undefined;
        var lastDate = undefined;
        var currentGroup = undefined;
        messages.forEach(function (m) {
            var _a, _b;
            var speaker = ((_b = (_a = m.payload.channel) === null || _a === void 0 ? void 0 : _a.web) === null || _b === void 0 ? void 0 : _b.userName) || m.authorId;
            var date = m.sentOn;
            // Create a new group if messages are separated by more than X minutes or if different speaker
            if (speaker !== lastSpeaker ||
                !currentGroup ||
                (0, difference_in_minutes_1.default)(new Date(date), new Date(lastDate)) >= constants_1.default.TIME_BETWEEN_DATES) {
                currentGroup = [];
                groups.push(currentGroup);
            }
            if (currentGroup.find(function (x) { return x.id === m.id; })) {
                return;
            }
            currentGroup.push(m);
            lastSpeaker = speaker;
            lastDate = date;
        });
        if (props.isBotTyping.get()) {
            if (lastSpeaker !== 'bot') {
                currentGroup = [];
                groups.push(currentGroup);
            }
            currentGroup.push({
                sentOn: new Date(),
                userId: undefined,
                payload: { type: 'typing' }
            });
        }
        return (react_1.default.createElement("div", null, groups.map(function (group, i) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            var lastGroup = groups[i - 1];
            var lastDate = (_a = lastGroup === null || lastGroup === void 0 ? void 0 : lastGroup[lastGroup.length - 1]) === null || _a === void 0 ? void 0 : _a.sentOn;
            var groupDate = group === null || group === void 0 ? void 0 : group[0].sentOn;
            var isDateNeeded = !groups[i - 1] ||
                (0, difference_in_minutes_1.default)(new Date(groupDate), new Date(lastDate)) > constants_1.default.TIME_BETWEEN_DATES;
            var _k = (0, last_1.default)(group), authorId = _k.authorId, payload = _k.payload;
            var avatar = authorId
                ? props.showUserAvatar && renderAvatar((_c = (_b = payload.channel) === null || _b === void 0 ? void 0 : _b.web) === null || _c === void 0 ? void 0 : _c.userName, (_e = (_d = payload.channel) === null || _d === void 0 ? void 0 : _d.web) === null || _e === void 0 ? void 0 : _e.avatarUrl)
                : renderAvatar(props.botName, ((_g = (_f = payload.channel) === null || _f === void 0 ? void 0 : _f.web) === null || _g === void 0 ? void 0 : _g.avatarUrl) || props.botAvatarUrl);
            return (react_1.default.createElement("div", { key: i },
                isDateNeeded && renderDate(group[0].sentOn),
                react_1.default.createElement(MessageGroup_1.default, { isBot: !authorId, avatar: avatar, userName: (_j = (_h = payload.channel) === null || _h === void 0 ? void 0 : _h.web) === null || _j === void 0 ? void 0 : _j.userName, key: "msg-group-".concat(i), isLastGroup: i >= groups.length - 1, messages: group })));
        })));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        state.showNewMessageIndicator && (react_1.default.createElement("div", { className: "bpw-new-messages-indicator", onClick: function (e) { return scrollToBottom(); } },
            react_1.default.createElement("span", null, props.intl.formatMessage({
                id: "messages.newMessage".concat(((_b = props.currentMessages) === null || _b === void 0 ? void 0 : _b.length) === 1 ? '' : 's')
            })))),
        renderMessageGroups()));
});
exports.default = (0, mobx_react_1.inject)(function (_a) {
    var store = _a.store;
    return ({
        intl: store.intl,
        isEmulator: store.isEmulator,
        botName: store.botName,
        isBotTyping: store.isBotTyping,
        botAvatarUrl: store.botAvatarUrl,
        currentMessages: store.currentMessages,
        focusPrevious: store.view.focusPrevious,
        focusNext: store.view.focusNext,
        focusedArea: store.view.focusedArea,
        showUserAvatar: store.config.showUserAvatar,
        enableArrowNavigation: store.config.enableArrowNavigation,
        preferredLanguage: store.preferredLanguage,
        alwaysScrollDownOnMessages: store.alwaysScrollDownOnMessages
    });
})((0, react_intl_1.injectIntl)((0, mobx_react_1.observer)(MessageList)));
